'use client';

import { useEffect } from 'react';
import { SignalMethod, SocketEndpoint } from './enum';
import { useSocketStore } from './use-socket-store';

export type ChannelListener = keyof typeof SignalMethod;
export type ListenerRecord = Partial<
    Record<ChannelListener, NonNullable<(data: any) => void>>
>;
export type SocketListenerProps = {
    endPoint: SocketEndpoint;
    listener: ListenerRecord;
};

/**
 * Hooks dùng để lắng nghe các channel của 1 hub cụ thể
 * Nên sử dụng useCallback cho hàm để tránh việc on,off hub liên tục
 */
export const useSocketListener = ({
    endPoint,
    listener,
}: SocketListenerProps) => {
    const hub = useSocketStore((x) => x.dictionaryHub[endPoint]);

    useEffect(() => {
        const arrChannelKey = Object.keys(listener);
        if (hub && arrChannelKey.length > 0) {
            for (let keyChannel of arrChannelKey) {
                const callback = listener?.[keyChannel as ChannelListener];
                if (callback) {
                    hub.on(keyChannel, callback);
                }
            }
        }

        return () => {
            for (let key of arrChannelKey) {
                const callback = listener?.[key as ChannelListener];

                if (callback) {
                    hub?.off(key, callback);
                }
            }
        };
    }, [hub, listener]);
};
